import { render, staticRenderFns } from "./sourceToStorage.vue?vue&type=template&id=20f3b2c5"
import script from "./sourceToStorage.vue?vue&type=script&lang=js"
export * from "./sourceToStorage.vue?vue&type=script&lang=js"
import style0 from "./sourceToStorage.vue?vue&type=style&index=0&id=20f3b2c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports